import {
  CONTENT_WIDTH,
  bottomMarginItemGlobal
} from "../../utils/pdfConstants";

export function renderMelutasotBlock({
  contentWidth = CONTENT_WIDTH,
  content = [],
  rakennusData,
  fontSize = 10
} = {}) {
  if (!content) {
    throw new Error("content is required");
  }

  const buildings =
    rakennusData?.rakennukset_fulls ||
    rakennusData?.rakennukset ||
    [];

  const smallFontSize = fontSize * 0.85;

  const GREEN = "#04aa00";
  const LIGHT_GREY = "#f0f0f0";
  const WHITE = "#ffffff";

  const renderCellValue = value => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "–";
    }

    return String(value);
  };

  const createCell = (
    text,
    {
      bold = false,
      color = "black",
      fillColor,
      alignment = "left"
    } = {}
  ) => ({
    text: renderCellValue(text),
    bold,
    color,
    fillColor,
    alignment,
    font: "Lato",
    fontSize: smallFontSize
  });

  // Collect all noise data
  const kaikkiMelutasot = buildings.flatMap(building => {
    return (
      building?.aluetiedot?.Melutasot?.value ||
      building?.aluetiedot?.Melutasot ||
      building?.aluetiedot?.melutasot ||
      building?.Melutasot ||
      []
    );
  });

  // Remove duplicates
  const melutasot = [];
  const seen = new Set();

  kaikkiMelutasot.forEach(item => {
    const key = [
      item?.lähde || "",
      item?.ajanjakso || "",
      item?.melutaso || ""
    ].join("|");

    if (!seen.has(key)) {
      seen.add(key);
      melutasot.push(item);
    }
  });

  const body = [
    [
      createCell("Melutasot", {
        bold: true,
        color: WHITE,
        fillColor: GREEN
      }),
      createCell("Arvo", {
        bold: true,
        color: WHITE,
        fillColor: GREEN
      })
    ]
  ];

  if (melutasot.length === 0) {
    body.push([
      {
        ...createCell(
          "Kohteelle ei löytynyt melualuetietoja.",
          {
            fillColor: LIGHT_GREY
          }
        ),
        colSpan: 2
      },
      {}
    ]);
  } else {
    melutasot.forEach((item, index) => {
      const fillColor =
        index % 2 === 0
          ? LIGHT_GREY
          : WHITE;

      const label = [
        item.lähde,
        item.ajanjakso
      ]
        .filter(Boolean)
        .join(" – ");

      body.push([
        createCell(label || "Melutaso", {
          fillColor
        }),

        createCell(
          item.melutaso
            ? `${item.melutaso} dB`
            : "–",
          {
            fillColor
          }
        )
      ]);
    });

    // Show source once at the bottom
    const aineisto =
      melutasot.find(item => item?.aineisto)?.aineisto;

    if (aineisto) {
      body.push([
        createCell("Aineisto"),
        createCell(aineisto)
      ]);
    }
  }

  const TABLE_WIDTH = contentWidth * 0.92;

  content.push({
    table: {
      widths: [
        TABLE_WIDTH * 0.47,
        TABLE_WIDTH * 0.58
      ],
      body
    },

    layout: {
      hLineWidth: () => 0,
      vLineWidth: () => 0,
      paddingLeft: () => 4,
      paddingRight: () => 4,
      paddingTop: () => 4,
      paddingBottom: () => 4,
      dontBreakRows: false
    },

  margin: [
  0,
  0,
  0,
  bottomMarginItemGlobal
]
  });
}